import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import {Pie} from 'react-chartjs-2';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import NoticeList from './NoticeList';



class NoticeBoard extends Component {
    constructor(props)
    {
        super(props);

        this.fetchGeneral = this.fetchGeneral.bind(this);
        this.renderAnnouncements = this.renderAnnouncements.bind(this);

        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            announcements:[],
            term: "",
            server_response:"",
            api_error:true,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }




  fetchGeneral()
  {

        this.setState({loading:true});
        let _this = this;

            const url = this.props.base_url +"/student/get_announcements";

            superagent
            .post(url)
            .send({"department":_this.props.student_details.department_id})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("General announcements", res.body);

              _this.setState({announcements:res.body.announcements.list, server_response:res.body.message,  loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});



            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, server_response:err, loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }



  



  renderAnnouncements()
  {
    const _this = this;

    let announcement_list;

    if(_this.state.announcements &&  _this.state.announcements.length > 0)
    {
        

            announcement_list = _this.state.announcements.map(an =>
                {
                console.log("announcement item", an);
                return (
                    <NoticeList key={an.id} an_details = {an} />
                        );
                });
        }
        else
        {
            announcement_list = <div> <p>No announcement available.</p> </div>;
        }


  

    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 tt">
          {announcement_list}
            

        </div>
    );
        


  }

  

  componentWillMount()
  {

    
    this.fetchGeneral();
    
  }

  render() {

    const _this=this;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading Announcements, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
          <div className="main-panel">

          <Header title ="Notice Board" />

          <div className="content">
          <div className="container-fluid">

            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style= {{fontWeight:"bold"}}>General Announcements</h4>


                                        {_this.renderAnnouncements()}



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>

            </div>
            </div>
            <Footer/>
            </div>





    );
  }
}

export default NoticeBoard;

